<div id="modal-decision">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" data-dismiss="modal-decision" (click)="cerrar('')"></button>
    </div>
    <div class="modal-body text-center">
        <div class="icons">
            <div class="swal2-icon swal2-info">i</div>
        </div>
        <span [outerHTML]="mensaje"></span>
    </div>

    <div class="modal-footer border-0">
        <button id="neoBtnAccept" type="button" class="btn btn-primary" (click)="cerrar('aceptar')">Aceptar</button>
    </div>
</div>
